<template>
  <v-layout
    v-if="status === 'error'"
    :style="`height: ${height}px;`"
    align-center
    justify-center
    fill-height
  >
    <span class="text--small text--center">
      {{ $t('Common.boxGenericError') }}<br>
      <a :title="$t('Common.tryAgain')" @click.prevent="tryAgain">
        {{ $t('Common.tryAgain') }}
      </a>
    </span>
  </v-layout>
</template>

<script>
export default {
  name: 'Error',
  props: {
    status: {
      type: String,
      default: 'loading'
    },
    height: {
      type: [String, Number]
    }
  },
  methods: {
    tryAgain () {
      this.$emit('tryAgain')
    }
  }
}
</script>
